(() => {
  function showFormResult(root = document) {
    const hash = location.hash.slice(1);
    if (!hash) return;
    const form = document.getElementById(hash);
    if (!form || !root.contains(form) || !form.matches('.cc-inquiry-form,.cc-newsletter-form')) return;
    const result = form.querySelector('[data-cc-form-result]');
    if (!result) return;
    result.focus({ preventScroll: true });
    result.scrollIntoView({ behavior: 'instant', block: 'center' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => showFormResult(), { once: true });
  else showFormResult();
  window.addEventListener('pageshow', () => showFormResult());
  document.addEventListener('shopify:section:load', () => showFormResult());
})();
